import React from "react";
import { useSnapshot } from "valtio";
import { voiceAgentStore } from "../../../../../store/voiceAgentStore";
import EndSessionButton from "./EndSessionButton";
import StartSessionButton from "./StartSessionButton";

const Controls: React.FC = () => {
  const { status } = useSnapshot(voiceAgentStore);

  const isSessionActive = status === "connected" || status === "connecting";

  return (
    <div className="absolute bottom-8 left-0 w-full flex items-center justify-center gap-4 px-4">
      {isSessionActive ? (
        <>
          <EndSessionButton />
        </>
      ) : (
        <StartSessionButton />
      )}
    </div>
  );
};

export default Controls;
